'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002e$002dHome$002dPage$0024 from "./presto.-Home-Page$.js";
import * as $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002449 from "./presto.-Presto-Router$$anon$49.js";
var $p;
/** @constructor */
function $c_Lpresto_PrestoRouter$$anon$48() {
  this.big = null;
  this.bi8 = null;
  this.bi9 = false;
  this.bih = null;
  this.bii = false;
  this.bil = null;
  this.bie = null;
  this.bif = false;
  this.bia = null;
  this.bib = false;
  this.bic = null;
  this.bid = false;
  this.bij = false;
  this.bik = false;
  this.big = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_derivation_Configuration$().u;
  this.bil = "HomePage";
}
export { $c_Lpresto_PrestoRouter$$anon$48 as $c_Lpresto_PrestoRouter$$anon$48 };
$p = $c_Lpresto_PrestoRouter$$anon$48.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_PrestoRouter$$anon$48;
/** @constructor */
function $h_Lpresto_PrestoRouter$$anon$48() {
}
export { $h_Lpresto_PrestoRouter$$anon$48 as $h_Lpresto_PrestoRouter$$anon$48 };
$h_Lpresto_PrestoRouter$$anon$48.prototype = $p;
$p.F = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_Decoder__tryDecode__Lio_circe_ACursor__s_util_Either(this, c);
});
$p.I = (function() {
  return this.big;
});
$p.M = (function() {
  if ((!this.bi9)) {
    this.bi8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__constructorNames__sci_List(this);
    this.bi9 = true;
  }
  return this.bi8;
});
$p.O = (function() {
  if ((!this.bii)) {
    this.bih = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__io$circe$derivation$ConfiguredDecoder$$decodersDict__sci_Map(this);
    this.bii = true;
  }
  return this.bih;
});
$p.E = (function() {
  return this.bil;
});
$p.t = (function() {
  if ((!this.bif)) {
    this.bie = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bif = true;
  }
  return this.bie;
});
$p.N = (function() {
  if ((!this.bib)) {
    this.bia = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sci_Nil$();
    this.bib = true;
  }
  return this.bia;
});
$p.Q = (function() {
  if ((!this.bid)) {
    this.bic = new $j_presto$002e$002dPresto$002dRouter$0024$0024anon$002449.$c_Lpresto_PrestoRouter$$anon$49();
    this.bid = true;
  }
  return this.bic;
});
$p.v = (function() {
  if ((!this.bik)) {
    this.bij = false;
    this.bik = true;
  }
  return this.bij;
});
$p.G = (function(c) {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lio_circe_derivation_ConfiguredDecoder__decodeProduct__Lio_circe_HCursor__F1__s_util_Either(this, c, new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((\u03b4scrutinee384) => ((p) => \u03b4scrutinee384))($j_presto$002e$002dHome$002dPage$0024.$m_Lpresto_HomePage$())));
});
var $d_Lpresto_PrestoRouter$$anon$48 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_PrestoRouter$$anon$48, "presto.PrestoRouter$$anon$48", ({
  Oo: 1,
  a: 1,
  f: 1,
  h: 1,
  d: 1
}));
export { $d_Lpresto_PrestoRouter$$anon$48 as $d_Lpresto_PrestoRouter$$anon$48 };
//# sourceMappingURL=presto.-Presto-Router$$anon$48.js.map
